module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerPlaceHolderForNewExclusiveRevamp) ? _c('div', {
    staticClass: "buy-exc-new container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(!_vm.dynamicExclusiveCards) ? _c('div', {
    staticClass: "col-sm-12 col-sm-6 col-lg-12"
  }, [_c('mainExclusiveCards', {
    attrs: {
      "isDesktop": _vm.isDesktop,
      "addExclusiveMem": _vm.addMembershipToCart,
      "title_content": _vm.title_content,
      "popular_head": _vm.popular_head,
      "card_inactive": _vm.card_inactive,
      "card_active": _vm.card_active,
      "add_to_cart_btn": _vm.add_to_cart_btn_new,
      "page": "exclusive"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dynamicExclusiveCards) ? _c('div', {
    staticClass: "col-sm-12 col-sm-6 col-lg-12"
  }, [_c('mainExcDynamicCardsVue', {
    attrs: {
      "isDesktop": _vm.isDesktop,
      "addExclusiveMem": _vm.addMembershipToCart,
      "title_content": _vm.title_content,
      "popular_head": _vm.popular_head,
      "card_inactive": _vm.card_inactive,
      "card_active": _vm.card_active,
      "add_to_cart_btn": _vm.add_to_cart_btn_new,
      "page": "exclusive"
    }
  })], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "buy-exc container-fluid",
    attrs: {
      "id": "buy-exc-membership"
    }
  }, [_c('div', {
    staticClass: "exc-title-div"
  }, [_c('h2', {
    staticClass: "exclusiveTitle"
  }, [_vm._v("BECOME A MEMBER")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-sm-6 col-lg-6"
  }, [_c('mainExclusiveCards', {
    attrs: {
      "addExclusiveMem": _vm.addMembershipToCart,
      "title_content": _vm.title_content,
      "popular_head": _vm.popular_head,
      "card_inactive": _vm.card_inactive,
      "card_active": _vm.card_active,
      "add_to_cart_btn": _vm.add_to_cart_btn,
      "page": "exclusive"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exc-title-div-new"
  }, [_c('span', {
    staticClass: "exclusiveTitleNew"
  }, [_vm._v("BECOME A MEMBER")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-009d7f7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExclusiveCard.vue
// module id = 2407
// module chunks = 24